import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { ROLES } from "../utils";

export const PrivateRoutes = ({ children, role }) => {
  const user = useSelector((state) => state.user);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (role && user.roleId !== ROLES[role]) {
    return <Navigate to="/" />;
  }

  return children;
};
